import React, { useEffect } from "react";
import { getFullName } from "../../components/util/helpers";
import {
  IonContent,
  IonPage,
  IonTitle,
  IonToolbar,
  IonHeader,
  IonBackButton,
  IonButtons,
  useIonModal,
} from "@ionic/react";
import { useSelector, useDispatch } from "react-redux";
import { loadRecord } from "./visitSlice";
import { useParams } from "react-router-dom";
import FormWrapper from "./form/FormWrapper";
import PatientCard from "../patient/PatientCard";
import Logo from "../../components/Logo";
import { useIntl } from "react-intl";

const Visit = (props) => {
  let { branchId, patientId, id } = useParams();
  const intl = useIntl();
  const loading = useSelector((state) => state.pendingActions["visit/load"]);
  const dispatch = useDispatch();
  const activeHouseVisit = useSelector((state) => state.visit.activeHouseVisit);

  const handleDismiss = () => {
    dismiss();
  };

  const [present, dismiss] = useIonModal(
    <PatientCard
      onHide={handleDismiss}
      patientId={patientId}
      branchId={branchId}
    />,
    {
      onDismiss: handleDismiss,
    },
  );

  useEffect(() => {
    const params = {
      patientId: patientId,
      branchId: branchId,
      admin: false,
      houseVisitsId: id,
    };
    dispatch(loadRecord(params));
  }, [branchId, dispatch, id, patientId]);

  const fullname =
    activeHouseVisit?.patient__surename && activeHouseVisit?.patient__first_name
      ? getFullName(
          activeHouseVisit.patient__surename,
          activeHouseVisit.patient__first_name,
        )
      : null;
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>{fullname && fullname}</IonTitle>
          <IonButtons slot="end">
            <Logo />
          </IonButtons>
          <IonButtons slot="start">
            <IonBackButton
              defaultHref="/app/visits"
              text={intl.formatMessage({
                id: "app.mobile.titles.visits",
              })}
            />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <FormWrapper
          present={present}
          branchId={branchId}
          patientId={patientId}
        />
      </IonContent>
    </IonPage>
  );
};

export default Visit;
